import axios from "axios";
import api from "./index";
import {
  Countries,
  CountryAdministrativeUnit,
  CountryAdministrativeUnitBlob,
} from "../types/countries";
import { GetApiResponse } from "../types/api";
import Cookies from "js-cookie";
import { staticDataBaseUrl } from "./index";

const accessToken = () => Cookies.get("accessToken");

export const getCountriesService = async ({
  useGeometry = false,
}: {
  useGeometry?: boolean;
}): Promise<GetApiResponse<Countries[]>> => {
  try {
    const response = await api.get<GetApiResponse<Countries[]>>(
      "/geography/countries",
      {
        params: { useGeometry },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCountryAdministrativeUnitService = async ({
  useGeometry = false,
  aggregationLevel,
  country,
  type,
}: {
  useGeometry?: boolean;
  aggregationLevel?: string;
  country?: string;
  type: string;
}): Promise<CountryAdministrativeUnitBlob | null> => {
  try {
    if (aggregationLevel) {
      const aggregations: any = {
        "0": "countries.geojson",
        "1": `adm1_by_country/${country}.geojson`,
        "2": `adm2_by_country/${country}.geojson`,
      };

      if (aggregations[aggregationLevel]) {
        const response = await axios.get<CountryAdministrativeUnitBlob>(
          `${staticDataBaseUrl}/geojson/${aggregations[aggregationLevel]}`,
        );

        return response.data;
      } else {
        const response = await api.get<
          GetApiResponse<CountryAdministrativeUnit[]>
        >("/geography/AdministrativeUnits", {
          params: {
            useGeometry: true,
            adminLevel: aggregationLevel,
            country,
            type,
          },
          headers: {
            ...(accessToken()
              ? { Authorization: `Bearer ${accessToken()}` }
              : {}),
          },
        });

        return {
          features: response.data.data[0].geometry?.features ?? [],
        };
      }
    }
    return null;
  } catch (error) {
    throw error;
  }
};
